import { render } from "./TopRefers.vue?vue&type=template&id=3ade1930&ts=true"
import script from "./TopRefers.vue?vue&type=script&lang=ts"
export * from "./TopRefers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__